import * as React from 'react'
import { useSnackbar } from 'notistack'
import styled from 'styled-components'
import { Close } from 'svgIcons'
import {
  NewsItemComment_NewsCommentEdgeFragment,
  useGqlMuteUserMutation,
} from 'generated/graphql'
import Button from '@app.components/Button'
import useChannelError from '@app.feature/channel/hook/useChannelError'
import Modal, { IFModalProps } from 'app.components/Modal/Modal'
import { mobileBreakPoint } from 'app.styled/media'

interface BanUserModalProps extends IFModalProps {
  data: NewsItemComment_NewsCommentEdgeFragment
}

const BanUserModal: React.FC<BanUserModalProps> = ({
  onClose,
  data,
  ...props
}) => {
  const { enqueueSnackbar } = useSnackbar()
  const onError = useChannelError()

  const muteUserMutation = useGqlMuteUserMutation({
    // update: muteUserUpdater(data.node.id),
    onCompleted: () => {
      enqueueSnackbar('회원이 차단되었습니다.')
    },
    onError,
  })

  const fetchMuteUser = () => {
    if (!data.node.author) return
    const [mutate] = muteUserMutation
    mutate({
      variables: {
        input: {
          mutedUserId: data.node.author.id,
          newsCommentId: data.node.id,
        },
      },
    })
  }

  const onConfirm = () => {
    fetchMuteUser()
    onClose && onClose()
  }

  return (
    <Modal onClose={onClose} {...props}>
      <StyledWrapper className="common-modal">
        <div className="close-btn" onClick={onClose}>
          <Close />
        </div>
        <div className="modal-title">이 회원을 차단하시겠어요?</div>
        <div className="modal-description">
          <p>회원 차단 시 아래와 같이 조치됩니다.</p>
          <ul>
            <li>
              채널 메뉴 내 모든 화면에서 이 회원의 댓글이 회원님에게 보이지
              않습니다.
            </li>
            <li>
              차단한 회원을 다시 보려면 차단된 회원 댓글의 [더보기] 버튼을
              선택하여 차단해제 해주세요.
            </li>
          </ul>
        </div>
        <div className="btn-list">
          <Button color="grey" className="btn cancle" onClick={onClose}>
            취소
          </Button>
          <Button className="btn" onClick={onConfirm}>
            확인
          </Button>
        </div>
      </StyledWrapper>
    </Modal>
  )
}

export default BanUserModal

const StyledWrapper = styled.div`
  width: 100%;
  max-width: 620px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: white;
  border-radius: 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 30px 0;

  .close-btn {
    align-self: flex-end;
    color: #999999;
    cursor: pointer;
    padding: 0 30px;
  }
  .modal-title {
    width: 100%;
    font-size: 24px;
    font-weight: 500;
    padding-bottom: 30px;
    text-align: center;
    border-bottom: 1px solid #eeeeee;
  }
  .modal-description {
    font-size: 16px;
    margin: 40px 0 30px;
    padding: 0 60px;
    width: 100%;
    p {
      margin-bottom: 12px;
    }
    li {
      position: relative;
      margin-bottom: 5px;
    }
  }
  .btn-list {
    display: flex;
    gap: 10px;
    margin-bottom: 20px;
    .btn {
      font-size: 16px;
      padding: 13px 30px;
      &.cancle {
        background-color: #bbbbbb;
      }
    }
  }
  ${mobileBreakPoint} {
    max-width: 350px;
  }
`
